module.exports = __webpack_public_path__ + "static/media/Artboard17.0b42d471.png";